@if ({
  largeScreenDownObserver: largeScreenDownObserver$ | async,
  }; as componentData) {
  @if (property) {
    <a
      class="container property-card"
      [ngStyle]="{ 'pointer-events': showOverlay ? 'none' : 'cursor' }"
    [ngClass]="{
      'vertical': orientation === 'vertical',
      'horizontal': orientation === 'horizontal',
      'mobile': componentData.largeScreenDownObserver,
      'on-map': onMap,
    }"
      (click)="navigateTo($event)">
      @if (showOverlay) {
        <div class="overlay">
          @if (property.STATUS === 'Withdrawn') {
            <div class="text-center">Property Withdrawn</div>
          }
          @if (property.STATUS === 'Pending 2nd Chance' || property.STATUS === 'Returned') {
            <div class="text-center">
              Temporarily Unavailable<br />
              <small> Check back soon </small>
            </div>
          }
        </div>
      }
      <div class="content-main">
        <!-- Vertical layout -->
        @if (orientation === 'vertical') {
          <ng-template [ngTemplateOutlet]="images" />
          @if (isTypeDefault) {
            <div class="content">
              <ng-template [ngTemplateOutlet]="footerDetails" />
              <ng-template [ngTemplateOutlet]="auction" [ngTemplateOutletContext]="{ labelConfig: 'short' }" />
            </div>
          }
          @if (isTypeAuction) {
            <div class="content">
              <ng-template [ngTemplateOutlet]="auction" [ngTemplateOutletContext]="{ labelConfig: 'short' }" />
              <ng-template [ngTemplateOutlet]="bid" />
              <ng-template [ngTemplateOutlet]="footerDetails" />
            </div>
          }
          <ng-template [ngTemplateOutlet]="saved" />
        }
        <!-- Horizontal layout -->
        @if (orientation === 'horizontal') {
          <ng-template [ngTemplateOutlet]="images" />
          @if (isTypeDefault) {
            <div class="content">
              <ng-template [ngTemplateOutlet]="footerDetails" />
              <ng-template [ngTemplateOutlet]="auction" [ngTemplateOutletContext]="{ labelConfig: onMap ? 'short' : 'long' }" />
            </div>
          }
          @if (isTypeAuction) {
            <div class="content">
              <ng-template [ngTemplateOutlet]="auction" [ngTemplateOutletContext]="{ labelConfig: onMap ? 'short' : 'long' }" />
              <ng-template [ngTemplateOutlet]="bid" />
              <ng-template [ngTemplateOutlet]="footerDetails" />
            </div>
          }
          <ng-template [ngTemplateOutlet]="saved" />
        }
        <!-- Templates -->
        <ng-template #images>
          <div class="image-container">
            <!-- For mobile on the map we don't need all the images, just main image to show -->
            @if (componentData.largeScreenDownObserver && onMap) {
              @if (mainPhoto$ | async; as photoData) {
                <img [src]="photoData.IMAGE_PATH" [alt]="photoData.IMAGE_DESCRIPTION" />
              }
            } @else {
              <app-galleria [property]="property" [fitImage]="true" [preload]="false" size="sm" />
            }
            <app-property-save-button class="save-button" [ITEM_ID]="property.ITEM_ID" />
            @if (!onMap) {
              <app-auction-type-indicator class="type" [categoryType]="uiData?.categoryId" [programRecordType]="property.PROGRAMRECORDTYPE" [cycle]="property.CYCLE" />
            }
          </div>
        </ng-template>
        <ng-template #bid>
          @if (uiData?.bidStatus) {
            <div class="bid">
              <div class="label footnote small-md">{{ uiData?.bidStatus }}</div>
              <div class="price subtitle">
                <ng-container>{{ uiData?.bidAmt | currency: 'USD' : 'symbol' : '1.0-0' }}</ng-container>
              </div>
            </div>
          }
        </ng-template>
        <ng-template #footerDetails>
          <div class="details">
            @if (!onMap) {
              <div class="location small">{{ uiData?.address }}</div>
            }
            @if (!onMap) {
              <div class="location small">{{ uiData?.city }}, {{ uiData?.state }}</div>
            }
            <div class="description footnote small-md">
              <span>{{ uiData?.bed }} Bd</span> / <span>{{ uiData?.bath }} Bath</span> / <span>{{ uiData?.sqft | number }} Sq Ft</span>
            </div>
            @if (uiData?.auctionStatus === auctionTimelineStates.AUCTION_FOR_ONLINE_FORECLOSURE_SALES_HAS_BEEN_POSTPONED && isSavedPropertiesPage) {
              <div
                class="description footnote small-md"
                >
                Auction Postponed
              </div>
            }
          </div>
        </ng-template>
        <ng-template #auction let-labelConfig="labelConfig">
          <div class="auction">
            @switch (property.CATEGORYID) {
              @case (propertyCategoryType.LIVE_FORECLOSURE_SALES) {
                <ng-container [ngTemplateOutlet]="foreclosure" />
              }
              @case (propertyCategoryType.LOCAL_COUNTY_ONLINE_FORECLOSURE_SALES) {
                <ng-container [ngTemplateOutlet]="foreclosure" />
              }
              @case (propertyCategoryType.ONLINE_FORECLOSURE_SALES) {
                <ng-container [ngTemplateOutlet]="ohio" />
              }
              @case (propertyCategoryType.MARKET_LISTING) {
                <ng-container [ngTemplateOutlet]="listing" />
              }
              @default {
                <ng-container [ngTemplateOutlet]="regular" />
              }
            }
          </div>
          <!-- REGULAR template covers all the states except exception like "Live Foreclosure" -->
          <ng-template #regular>
            @switch (uiData?.auctionStatus) {
              <!-- SOLD STATE -->
              @case (auctionTimelineStates.AUCTION_HAS_ENDED_AS_SOLD) {
                <div class="label footnote small-md">{{ uiData?.activeDateTitle }} {{ uiData?.activeDate | date: 'EEEE, MMMM d' }}</div>
                <h4 class="final-state">SOLD</h4>
              }
              <!-- RETURNED STATE -->
              @case (auctionTimelineStates.AUCTION_HAS_ENDED_AS_RETURNED) {
                <h5 class="final-state">This auction has ended</h5>
              }
              <!-- ALL OTHER STATES -->
              @default {
                <div class="label footnote small-md">{{ uiData?.activeDateTitle }}</div>
                @if (uiData?.activeDate) {
                  <div class="countdown-timer">
                    <app-countdown-timer [auctionDate]="property.STATUS === 'Withdrawn' ? null : uiData?.activeDate" [segmentLabel]="labelConfig" />
                  </div>
                } @else {
                  <div class="date subtitle">
                    <h6 class="date-or-tbd">TBD</h6>
                  </div>
                }
                <!-- Countdown timer only when date is defined -->
                <!-- If no date defined then show TBD -->
              }
            }
          </ng-template>
          <!-- FORECLOSURES -->
          <ng-template #foreclosure>
            @switch (uiData?.auctionStatus) {
              @case (auctionTimelineStates.AUCTION_HAS_ENDED_AS_SOLD) {
                <div class="label footnote small-md">
                  {{ orientation === 'horizontal' ? uiData?.activeDateTitle : '' }}
                  <span class="fw-bold">{{ uiData?.activeDate | date: 'mediumDate' }}</span>
                </div>
                <h4 class="final-state">SOLD</h4>
              }
              @case (auctionTimelineStates.AUCTION_FOR_ONLINE_FORECLOSURE_SALES_HAS_BEEN_POSTPONED) {
                <div class="label footnote small-md">
                  Auction Postponed<br />
                  {{ uiData?.activeDateTitle }}
                </div>
                <ng-container [ngTemplateOutlet]="auctionPostponed" />
              }
              @case (auctionTimelineStates.AUCTION_HAS_ENDED_AS_RETURNED) {
                <h5 class="final-state">This auction has ended</h5>
              }
              @default {
                <div class="label footnote small-md">{{ uiData?.activeDateTitle }}</div>
                <h6 class="date-or-tbd">
                  {{ uiData?.activeDate ? (uiData?.activeDate | date: 'EEEE, MMMM d') : 'TBD' }}
                </h6>
              }
            }
          </ng-template>
          <!-- OHIO case -->
          <ng-template #ohio>
            @switch (uiData?.auctionStatus) {
              @case (auctionTimelineStates.AUCTION_HAS_ENDED_AS_SOLD) {
                <div class="label footnote small-md">{{ uiData?.activeDateTitle }} {{ uiData?.activeDate | date: 'EEEE, MMMM d' }}</div>
                <h4 class="final-state">SOLD</h4>
              }
              @case (auctionTimelineStates.AUCTION_HAS_ENDED_AS_RETURNED) {
                <h5 class="final-state">This auction has ended</h5>
              }
              @case (auctionTimelineStates.AUCTION_FOR_ONLINE_FORECLOSURE_SALES_HAS_BEEN_CANCELLED) {
                <div class="label footnote small-md">
                  {{ uiData?.activeDateTitle }} <strong>{{ uiData?.activeDate | date: 'mediumDate' }}</strong>
                </div>
                <h5 class="final-state">Auction has been cancelled</h5>
              }
              @case (auctionTimelineStates.AUCTION_FOR_ONLINE_FORECLOSURE_SALES_HAS_BEEN_POSTPONED) {
                <div class="label footnote small-md">
                  Auction Postponed<br />
                  {{ uiData?.activeDateTitle }}
                </div>
                <ng-container [ngTemplateOutlet]="auctionPostponed" />
              }
              @default {
                <div class="label footnote small-md">{{ uiData?.activeDateTitle }}</div>
                @if (uiData?.activeDate) {
                  <div class="countdown-timer">
                    <app-countdown-timer [auctionDate]="property.STATUS === 'Withdrawn' ? null : uiData?.activeDate" [segmentLabel]="labelConfig" />
                  </div>
                } @else {
                  <div class="date subtitle">
                    <h6 class="date-or-tbd">TBD</h6>
                  </div>
                }
                <!-- Countdown timer only when date is defined -->
                <!-- If no date defined then show TBD -->
              }
            }
          </ng-template>
          <!-- Marketing listing-->
          <ng-template #listing>
            <tr>
              <td class="label footnote small-md">List Price:</td>
              <td class="price subtitle">
                {{ uiData?.estimatedvalue | currency: 'USD' : 'symbol' : '1.0-0' }}
              </td>
            </tr>
          </ng-template>
        </ng-template>
        <ng-template #saved />
        <ng-template #auctionPostponed>
          @if (orientation === 'vertical' && !isHomePage && !onMap && componentData.largeScreenDownObserver && !isSavedPropertiesPage) {
            <h4 class="final-state">
              <strong>{{ uiData?.activeDate | date: 'EEEE, MMMM d' }}</strong>
            </h4>
          }
          @if ((orientation === 'horizontal' && !componentData.largeScreenDownObserver) || (orientation === 'horizontal' && !onMap)) {
            <h6
              class="date-or-tbd final-state"
              >
              {{ uiData?.activeDate | date: 'EEEE, MMMM d' }}
            </h6>
          }
          @if (
            (!isHomePage && orientation === 'vertical' && !isSavedPropertiesPage && !componentData.largeScreenDownObserver) ||
            (orientation === 'horizontal' && onMap)
            ) {
            <div
              class="label footnote small-md"
              >
              Auction postponed
            </div>
          }
        </ng-template>
      </div>
      @if (showDeleteIcon && property.ITEM_ID) {
        <a class="delete" (click)="deleteSavedProperty(property.ITEM_ID)"><fa-icon icon="trash" /></a>
      }
    </a>
  }
}
